// src/components/Gallery/ModelCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const ModelCard = ({ model }) => {
  return (
    <div className="bg-gray-800 border border-orange-400 rounded-xl p-4 shadow hover:shadow-orange-400/20 transition">
      <img
        src={model.images[0]}
        alt={model.name}
        className="w-full h-48 object-cover rounded-md mb-4"
      />
      <h2 className="text-xl font-semibold mb-2">{model.name}</h2>
      <p className="text-sm text-gray-400 mb-3">{model.description}</p>
      <Link
        to={`/model/${model.slug}`}
        className="text-orange-400 font-medium hover:underline"
      >
        View Model →
      </Link>
    </div>
  );
};

export default ModelCard;
